var map = {
	"./Palestra1.jpg": "e338",
	"./Palestra10.jpg": "5c9b",
	"./Palestra11.jpg": "a252",
	"./Palestra12.jpg": "d56a",
	"./Palestra13.jpg": "31e2",
	"./Palestra13_2.jpg": "88fe",
	"./Palestra2.jpg": "f2ff",
	"./Palestra3.jpg": "7ce9",
	"./Palestra4.jpg": "e502",
	"./Palestra5.jpg": "e2ce",
	"./Palestra6.jpg": "3fd9",
	"./Palestra7.jpg": "af57",
	"./Palestra8.jpg": "c61f",
	"./Palestra9.jpg": "9871",
	"./Palestra_home1.jpg": "6d8d",
	"./Palestra_home1_big.jpg": "ea0a",
	"./Palestra_home1_old.jpg": "bf33",
	"./Palestra_home2.jpg": "7b3d",
	"./Palestra_home3.jpg": "12ab",
	"./Palestra_home4.jpg": "2f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2768";